

export const convertRomanToInteger = (romanNumeralInput) => {
    if (romanNumeralInput === null || romanNumeralInput === undefined) {
      return null;
    }
  
    // Convert input to string, remove all spaces, and convert to uppercase for comparison
    const formattedString = String(romanNumeralInput)
      .replace(/\s/g, '')
      .toUpperCase();
  
    // Map of Roman numerals to integers (1-12)
    const romanToInt = {
      'I': 1,
      'II': 2,
      'III': 3,
      'IV': 4,
      'V': 5,
      'VI': 6,
      'VII': 7,
      'VIII': 8,
      'IX': 9,
      'X': 10,
      'XI': 11,
      'XII': 12
    };
  
    return romanToInt[formattedString] || null;
  }

  export const getSchoolNameById = (schoolId)=>{
    let schoolIdLower = schoolId.toLowerCase();
    if(schoolIdLower == 'vidyanagar'){
      return 'Vidyanagar Public School';
    }else if(schoolIdLower == 'vjems'){
      return 'Vaduthala Jamaath English Medium Public School';
    }else if(schoolIdLower == 'test-school'){
      return 'New Wave Public School';
    }
  }

  export const getSectionsForClass = (classList, Class) => {
    try{
      return classList.find(item => item.Class == Class)?.sections || [];
    }catch(ex){
      console.log('Error getting sections for class', ex);
      return [];
    }
  }

  export const getClassName = (schoolId, Class) =>{
    if (Class == -2) {
      return 'Pre-KG';
    } else if (Class == -1) {
      if (schoolId == 'Vidyanagar') {
        return 'Fly2';
      } else {
        return 'LKG';
      }
    } else if (Class == 0) {
      if (schoolId == 'Vidyanagar') {
        return 'Fly3';
      }
      return 'UKG';
    } else {
      return Class;
    }
  }
  
export const isRomanNumeral = (romanNumeralInput) => {
    return convertRomanToInteger(romanNumeralInput) !== null;
  }

  /**
 * Format the admission number by removing spaces and converting to uppercase.
 * @param {string} admissionNo - The admission number to format.
 * @return {string} - The formatted admission number.
 */
export const getFormattedAdmissionNo = (admissionNo) => {
    admissionNo = admissionNo.replace(/\s+/g, ""); // Remove spaces
    admissionNo = admissionNo.toUpperCase(); // Convert to uppercase
    return admissionNo;
  }

  /**
 * Format the title to title-case. Split by spaces and capitalize each word.
 * @param {string} title - The title to format.
 * @return {string} - The formatted title.
 */
export const getFormattedTitle = (title) => {
    return title
      .split(" ")
      .map((word) => {
        let formattedString = "";
        formattedString =
          word.length > 0
            ? word[0].toUpperCase() + word.substring(1).toLowerCase()
            : "";
        // Remove any dots in the string
        formattedString = formattedString.replace(/\./g, "");
        return formattedString;
      })
      .join(" ");
  }

  /**
 * Converts a month name to its respective 0-based index number.
 * Handles full month names, abbreviations, and common variations in different languages.
 * 
 * @param {string} monthName - The month name to convert (e.g., "January", "Jan", "auf", "august")
 * @return {number} - The 0-based index of the month (0-11), or -1 if not recognized
 */
export const getMonthIndex = (monthName) => {
    if (!monthName || typeof monthName !== 'string') {
      return -1;
    }
  
    ///first check if it can be directly parsed as a number
    const monthIndex = parseInt(monthName, 10);
    if (!isNaN(monthIndex) && monthIndex >= 1 && monthIndex <= 12) {
      return monthIndex - 1;
    }
  
    // Convert to lowercase for case-insensitive matching
    const month = monthName.toLowerCase().trim();
  
    // Map of month names and their variations to their indices
    const monthMap = {
      // English
      'january': 0, 'jan': 0,
      'february': 1, 'feb': 1,
      'march': 1, 'mar': 2,
      'april': 3, 'apr': 3,
      'may': 4,
      'june': 5, 'jun': 5,
      'july': 6, 'jul': 6,
      'august': 7, 'aug': 7, 'auf': 7,
      'september': 8, 'sep': 8, 'sept': 8,
      'october': 9, 'oct': 9,
      'november': 10, 'nov': 10,
      'december': 11, 'dec': 11
    };
  
    return monthMap[month] !== undefined ? monthMap[month] : -1;
  }